export default "__VITE_ASSET__BJ$UJmMy__"